'use client';

import { cn } from '@/lib/utils';
import { useCountdown } from '@/lib/utilHooks';
import { CTAButton } from '@/shadcn/ui/button';
import { PageFuturesOldDesignSchema } from '@/sanity/pages/PageFuturesOldDesignTemplate';

function DigitBox({ digit }: { digit: string }) {
  return (
    <div className="bg-[rgba(7,23,27,0.1)] flex flex-col items-center justify-center p-[0.75rem] rounded-[0.375rem] min-w-[3rem]">
      <p className="font-normal leading-[1.2] text-[#07171b] text-[2.25rem] text-center tracking-[-0.04rem] whitespace-nowrap mb-0">
        {digit}
      </p>
    </div>
  );
}

function CountdownUnit({ value, label }: { value: string; label: string }) {
  return (
    <div className="flex flex-col gap-[4px] items-center">
      <div className="flex gap-[1rem] items-start">
        {value.split('').map((d, i) => (
          <DigitBox key={i} digit={d} />
        ))}
      </div>
      <p className="font-medium leading-[1.2] opacity-30 text-[#07171b] text-[1.25rem] text-center uppercase whitespace-nowrap mb-0">
        {label}
      </p>
    </div>
  );
}

export default function HeroPricingCard({
  data,
  className,
}: {
  data: PageFuturesOldDesignSchema;
  className?: string;
}) {
  const { days, hours, minutes, seconds } = useCountdown(
    data.pricingDeadline ?? null,
    'Europe/Berlin',
  );

  const hasOffer = data.pricingPrice || data.pricingCTA || data.pricingDeadline;

  if (!hasOffer) return null;

  return (
    <div
      className={cn(
        'bg-[#ebf3f0] flex flex-col gap-[5rem] items-center overflow-clip p-[3rem] rounded-[2rem] w-[min(51.5rem,100%)]',
        className,
      )}
    >
      {/* Price section */}
      {(data.pricingPrice ||
        data.pricingOriginalPrice ||
        data.pricingInfoLines?.length > 0) && (
        <div className="flex flex-col gap-[0.5rem]  items-center leading-[1.2] px-[1rem] text-[#103037] w-full">
          <div className="flex  flex-col gap-[0.5rem] items-center">
            {data.pricingPrice && (
              <p className="font-semibold text-[6rem] tracking-[-0.12rem] mb-0">
                {data.pricingPrice}
              </p>
            )}
            {data.pricingOriginalPrice && (
              <p className="font-medium line-through text-[2.5rem] tracking-[-0.05rem] mb-0">
                {data.pricingOriginalPrice}
              </p>
            )}
          </div>
          {data.pricingInfoLines?.map((line, i) => (
            <p
              key={i}
              className="font-normal opacity-60 text-[2rem] tracking-[-0.04rem] text-center mb-0"
            >
              {line}
            </p>
          ))}
        </div>
      )}

      {/* CTA section */}
      {(data.pricingCTA || data.pricingCTASubtext) && (
        <div className="flex flex-col gap-[12px] items-center w-full">
          {data.pricingCTA && (
            <CTAButton className="w-full" data={data.pricingCTA} />
          )}
          {data.pricingCTASubtext && (
            <p className="font-normal leading-[1.2] opacity-60 text-[#103037] text-[2rem] text-center tracking-[-0.04rem] w-full">
              {data.pricingCTASubtext}
            </p>
          )}
        </div>
      )}

      {/* Countdown section */}
      {/* {data.pricingDeadline && (
        <div className="flex flex-col gap-[8px] items-center justify-center w-full">
          {data.pricingTimerLabel && (
            <p className="font-normal leading-[1.2] opacity-60 text-[#103037] text-[2rem] text-center tracking-[-0.04rem] w-full">
              {data.pricingTimerLabel}
            </p>
          )}
          <div className="flex gap-[1rem] items-start">
            <CountdownUnit value={days} label="Tage" />
            <CountdownUnit value={hours} label="Stunden" />
            <CountdownUnit value={minutes} label="Minuten" />
            <CountdownUnit value={seconds} label="Sekunden" />
          </div>
        </div>
      )} */}
    </div>
  );
}
